import { useState, useEffect } from "react";

const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
};

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
};

const Analytics = () => {
    const [hasSent, setHasSent] = useState(false);
    useEffect(() => {
        if (!hasSent) {
            const referrer = document.referrer || "direct";
            const today = new Date().toISOString().split("T")[0];
            const isUnique = !getCookie("visited_today");

            fetch("/.netlify/functions/trackVisit", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ referrer, isUnique }),
            }).catch((err) => console.error("Analytics error:", err));

            setCookie("visited_today", today, 1);
            setHasSent(true);
        }

    }, [hasSent]);

    return null;
};

export default Analytics;
